import { render, staticRenderFns } from "./ViewPost.vue?vue&type=template&id=b1e0e320"
import script from "./ViewPost.vue?vue&type=script&lang=js"
export * from "./ViewPost.vue?vue&type=script&lang=js"
import style0 from "./ViewPost.vue?vue&type=style&index=0&id=b1e0e320&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports